import {createReducer} from "redux-act";
import {LeaderboardsType, RequestState} from "modules/enums";
import {ILeaderboardsReducer} from "modules/types";
import {
	clearFetchedPagesLeaderboards,
	clearLeaderboard,
	fetchAllLeaderboardsData,
	fetchAllLeaderboardsDataFailed,
	fetchAllLeaderboardsDataSuccess,
	fetchLeaderboardSuccess,
	fetchLeaderProfile,
	fetchLeaderProfileFailed,
	fetchLeaderProfileSuccess,
	setSelectedLeaderboard,
} from "modules/actions";
import {uniq} from "lodash";

const initialState: ILeaderboardsReducer = {
	loadingState: RequestState.IDLE,
	leaderboards: {
		ranks: [],
		user: null,
		nextPage: false,
		allParticipantsCount: 0,
		updatedAt: "",
	},
	fetchedPages: [],
	selectedLeaderboard: LeaderboardsType.Daily,
	_lastRequestedProfile: null,
	profiles: {},
	profileRequestState: RequestState.IDLE,
};

export const leaderboards = createReducer({}, initialState)
	.on(fetchLeaderboardSuccess, (state, payload) => ({
		...state,
		leaderboards: payload,
		loadingState: RequestState.Received,
	}))
	.on(fetchAllLeaderboardsData, (state, payload) => ({
		...state,
		loadingState: RequestState.Requested,
		fetchedPages: uniq([...state.fetchedPages, payload.page]),
	}))
	.on(fetchAllLeaderboardsDataSuccess, (state) => ({
		...state,
		loadingState: RequestState.Received,
	}))
	.on(fetchAllLeaderboardsDataFailed, (state) => ({
		...state,
		loadingState: RequestState.IDLE,
	}))
	.on(setSelectedLeaderboard, (state, {value}) => ({
		...state,
		selectedLeaderboard: value,
	}))
	.on(clearFetchedPagesLeaderboards, (state) => ({
		...state,
		fetchedPages: [],
	}))
	.on(clearLeaderboard, (state) => ({
		...state,
		leaderboards: {
			ranks: [],
			user: null,
			nextPage: false,
			allParticipantsCount: 0,
			updatedAt: "",
		},
		fetchedPages: [],
	}))
	.on(fetchLeaderProfile, (state, {userId}) => ({
		...state,
		_lastRequestedProfile: userId,
		profileRequestState: RequestState.Requested,
	}))
	// .on(showUpdateNotice, (state, payload) => ({
	// 	...state,
	// 	isVisibleUpdateNotice: payload,
	// }))
	.on(fetchLeaderProfileSuccess, (state, payload) => ({
		...state,
		_lastRequestedProfile: null,
		profiles: state._lastRequestedProfile
			? {
					...state.profiles,
					[state._lastRequestedProfile]: payload,
			  }
			: state.profiles,
		profileRequestState: RequestState.Received,
	}))
	.on(fetchLeaderProfileFailed, (state) => ({
		...state,
		_lastRequestedProfile: null,
		profileRequestState: RequestState.IDLE,
	}));
